"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOOP_LOGGER = void 0;
exports.NOOP_LOGGER = Object.freeze({
    debug: function () { return this; },
    info: function () { return this; },
    warn: function () { return this; },
    error: function () { return this; }
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguY29uc3QuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXguY29uc3QudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxXQUFXLEdBQVcsTUFBTSxDQUFDLE1BQU0sQ0FBQztJQUMvQyxLQUFLLEVBQUUsY0FBYyxPQUFPLElBQUksQ0FBQSxDQUFDLENBQUM7SUFDbEMsSUFBSSxFQUFFLGNBQWMsT0FBTyxJQUFJLENBQUEsQ0FBQyxDQUFDO0lBQ2pDLElBQUksRUFBRSxjQUFjLE9BQU8sSUFBSSxDQUFBLENBQUMsQ0FBQztJQUNqQyxLQUFLLEVBQUUsY0FBYyxPQUFPLElBQUksQ0FBQSxDQUFDLENBQUM7Q0FDbkMsQ0FBQyxDQUFBIn0=